"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Namespace for dom interactions w/ related links & addtess item
 * in marginal column
 *
 * @namespace
 * @memberOf txGs1Base.content
 * @public
 */
const _main_1 = require("../_main");
_main_1.txGs1Base.content = {};
_main_1.txGs1Base.content.marginal = {
    contentContainer: $('#content'),
    relationsItem: $.noop(),
    addressItem: $.noop(),
    /**
     * "Move" items to end of page
     *
     * @namespace
     * @memberOf txGs1Base.content.marginal
     * @public
     */
    moveToEndOfPage: function () {
        'use strict';
        _main_1.txGs1Base.content.marginal.contentContainer.append('<div id="js_shifted_wrapper"></div>');
        _main_1.txGs1Base.content.marginal.addressItem.hide();
        _main_1.txGs1Base.content.marginal.relationsItem.hide();
        _main_1.txGs1Base.content.marginal.addressItem.clone().appendTo($('#js_shifted_wrapper')).show().addClass('js-shifted');
        _main_1.txGs1Base.content.marginal.relationsItem.clone().appendTo($('#js_shifted_wrapper')).show().addClass('js-shifted');
    },
    /**
     * "Move" item back to origin
     *
     * @namespace
     * @memberOf txGs1Base.content.marginal
     * @public
     */
    moveToOrigin: function () {
        'use strict';
        $(_main_1.txGs1Base.content.marginal.contentContainer).find('#js_shifted_wrapper').remove();
        _main_1.txGs1Base.content.marginal.relationsItem.show();
        _main_1.txGs1Base.content.marginal.addressItem.show();
    },
    /**
     * Init function
     *
     * @namespace
     * @memberOf txGs1Base.content.marginal
     * @public
     */
    initialize: function () {
        'use strict';
        _main_1.txGs1Base.content.marginal.relationsItem = $('.tx-gs1relations-pi-list').parent();
        _main_1.txGs1Base.content.marginal.addressItem = $('.marginal .wrapper-tt-address-item');
        _main_1.txGs1Base.respond.addFunc({
            breakpoint: ['handheld'],
            enter: function () {
                _main_1.txGs1Base.content.marginal.moveToEndOfPage();
            },
            exit: function () {
                _main_1.txGs1Base.content.marginal.moveToOrigin();
            }
        });
    }
};
exports.default = {};
